"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var storeApi = _interopRequireWildcard(require("@/api/store"));
var toolUtils = _interopRequireWildcard(require("@/utils/toolUtils"));
var _UseDetailDialog = _interopRequireDefault(require("./components/UseDetailDialog.vue"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t2 in e) "default" !== _t2 && {}.hasOwnProperty.call(e, _t2) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t2)) && (i.get || i.set) ? o(f, _t2, i) : f[_t2] = e[_t2]); return f; })(e, t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'CardInventoryDetail',
  components: {
    UseDetailDialog: _UseDetailDialog.default
  },
  data: function data() {
    return {
      skuId: '',
      productName: '',
      cardType: 0,
      loading: false,
      exportLoading: false,
      tableData: [],
      total: 0,
      customerOptions: [],
      importDialogVisible: false,
      importFileName: '',
      importFileRaw: null,
      importSubmitting: false,
      searchPram: {
        page: 1,
        limit: 20,
        batchNo: '',
        cardNo: '',
        cardStatus: '',
        cardUseStatus: '',
        phone: '',
        channelType: '',
        customerId: '',
        createTime: []
      }
    };
  },
  mounted: function mounted() {
    this.skuId = this.$route.params.skuId;
    this.productName = this.$route.query.productName || '';
    this.cardType = Number(this.$route.query.cardType || 0);
    if (!this.isMeijingCard) this.loadCustomerOptions();
    this.getList();
  },
  methods: {
    openImportDialog: function openImportDialog() {
      this.importDialogVisible = true;
    },
    resetImportDialog: function resetImportDialog() {
      var _this = this;
      this.importFileName = '';
      this.importFileRaw = null;
      this.importSubmitting = false;
      this.$nextTick(function () {
        if (_this.$refs.importUpload) _this.$refs.importUpload.clearFiles();
      });
    },
    handleDownloadTemplate: function () {
      var _handleDownloadTemplate = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              _context.n = 1;
              return storeApi.downloadMeijingOneCardImportTemplate();
            case 1:
              res = _context.v;
              window.open(res.fileName, '_blank');
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              this.$message.error('下载模板失败');
            case 3:
              return _context.a(2);
          }
        }, _callee, this, [[0, 2]]);
      }));
      function handleDownloadTemplate() {
        return _handleDownloadTemplate.apply(this, arguments);
      }
      return handleDownloadTemplate;
    }(),
    handleImportFileChange: function handleImportFileChange(file) {
      var raw = file && file.raw;
      if (!raw) return;
      var ext = (raw.name || '').split('.').pop().toLowerCase();
      if (ext !== 'xlsx') {
        this.$message.warning('仅支持 .xlsx 文件');
        this.handleRemoveImportFile();
        return;
      }
      this.importFileRaw = raw;
      this.importFileName = raw.name;
    },
    handleRemoveImportFile: function handleRemoveImportFile() {
      var _this2 = this;
      this.importFileName = '';
      this.importFileRaw = null;
      this.$nextTick(function () {
        if (_this2.$refs.importUpload) _this2.$refs.importUpload.clearFiles();
      });
    },
    handleConfirmImport: function () {
      var _handleConfirmImport = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var formData;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              if (this.importFileRaw) {
                _context2.n = 1;
                break;
              }
              this.$message.warning('请先选择导入文件');
              return _context2.a(2);
            case 1:
              formData = new FormData();
              formData.append('file', this.importFileRaw);
              this.importSubmitting = true;
              _context2.p = 2;
              _context2.n = 3;
              return storeApi.oneCardMeijingImport(formData, this.skuId);
            case 3:
              this.$message.success('导入成功');
              this.importDialogVisible = false;
              this.getList();
            case 4:
              _context2.p = 4;
              this.importSubmitting = false;
              return _context2.f(4);
            case 5:
              return _context2.a(2);
          }
        }, _callee2, this, [[2,, 4, 5]]);
      }));
      function handleConfirmImport() {
        return _handleConfirmImport.apply(this, arguments);
      }
      return handleConfirmImport;
    }(),
    goBack: function goBack() {
      this.$router.go(-1);
    },
    getList: function getList() {
      var _this3 = this;
      this.loading = true;
      storeApi.cardInstanceCardPage(this.buildQueryParams(true)).then(function (res) {
        var data = res || {};
        _this3.tableData = data.list || [];
        _this3.total = data.total || 0;
      }).catch(function () {
        _this3.tableData = [];
        _this3.total = 0;
      }).finally(function () {
        _this3.loading = false;
      });
    },
    buildQueryParams: function buildQueryParams(withPage) {
      var params = {
        skuId: this.skuId,
        batchNo: this.searchPram.batchNo || undefined,
        cardNo: this.searchPram.cardNo || undefined,
        cardStatus: this.searchPram.cardStatus || undefined,
        cardUseStatus: this.isMeijingCard ? undefined : this.searchPram.cardUseStatus || undefined,
        phone: this.isMeijingCard ? undefined : this.searchPram.phone || undefined,
        channelType: this.searchPram.channelType || undefined,
        customerId: this.isMeijingCard ? undefined : this.searchPram.customerId || undefined
      };
      var _ref = this.searchPram.createTime || [],
        _ref2 = _slicedToArray(_ref, 2),
        startTime = _ref2[0],
        endTime = _ref2[1];
      if (startTime && endTime) {
        params.startTime = startTime;
        params.endTime = endTime;
      }
      if (withPage) {
        params.page = this.searchPram.page;
        params.limit = this.searchPram.limit;
      }
      return params;
    },
    loadCustomerOptions: function loadCustomerOptions() {
      var _this4 = this;
      storeApi.cardCustomerAppOptions().then(function (res) {
        var raw = res || [];
        _this4.customerOptions = raw.map(function (item) {
          return {
            label: item.name || '',
            value: Number(item.id)
          };
        });
      }).catch(function () {
        _this4.customerOptions = [];
      });
    },
    onSearch: function onSearch() {
      this.searchPram.page = 1;
      this.getList();
    },
    onReset: function onReset() {
      this.searchPram = {
        page: 1,
        limit: 20,
        batchNo: '',
        cardNo: '',
        cardStatus: '',
        cardUseStatus: '',
        phone: '',
        channelType: '',
        customerId: '',
        createTime: []
      };
      this.getList();
    },
    onExport: function onExport() {
      var _this5 = this;
      this.exportLoading = true;
      storeApi.cardInstanceCardExport(this.buildQueryParams(false)).then(function (res) {
        if (!res || !res.fileName) {
          _this5.$message.warning('未获取到导出文件');
          return;
        }
        toolUtils.downloadFile(res.fileName, '一卡通库存详情.xlsx');
        _this5.$message.success('导出任务已生成');
      }).finally(function () {
        _this5.exportLoading = false;
      });
    },
    handleUseDetail: function handleUseDetail(row) {
      this.$refs.useDetailDialog.open(row.id);
    },
    handleSizeChange: function handleSizeChange(val) {
      this.searchPram.limit = val;
      this.searchPram.page = 1;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.searchPram.page = val;
      this.getList();
    },
    cardStatusText: function cardStatusText(val) {
      var map = {
        1: '已入库',
        2: '下单锁定',
        3: '已发放未激活',
        4: '已激活',
        5: '已过期',
        6: '已作废',
        8: '可使用',
        9: '未开始'
      };
      return map[val] != null ? map[val] : '-';
    },
    cardStatusTagType: function cardStatusTagType(val) {
      var map = {
        1: 'info',
        2: 'warning',
        3: '',
        4: 'success',
        5: 'info',
        6: 'danger',
        8: 'success',
        9: 'warning'
      };
      return map[val] != null ? map[val] : 'info';
    },
    maskCardPwd: function maskCardPwd(row) {
      if (row.cardStatus === 1 || row.cardStatus === 2) {
        var p = row.cardSecret || '';
        if (p.length > 8) {
          return p.slice(0, 4) + '********' + p.slice(-4);
        }
        return p;
      }
      return row.cardSecret || '-';
    }
  },
  computed: {
    isMeijingCard: function isMeijingCard() {
      return this.cardType === 1;
    }
  }
};